<script setup lang="ts">

</script>

<template>
  <dashboard-layout currentRoute="support/guide" page-title="Hướng dẫn nghiệp vụ">

  </dashboard-layout>
</template>

<style scoped>

</style>
